import {
  MenuItem,
  // OutlinedInput,
  // InputLabel,
  // FormControl,
  // ListItemText,
  // Checkbox,
  Select,
  // Chip,
  // Box,
} from "@material-ui/core";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
// import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import Chip from "@mui/material/Chip";
import Box from "@mui/material/Box";
import { useState } from "react";
import { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  menuList: {
    maxWidth: "fit-content;",
  },
}));

const VariationInput = ({ variationTags, variationTitle, getVariationTags, product, index }) => {
  const [tagsChanged, setTagsChanged] = useState([]);
  const classes = useStyles();

  useEffect(() => {
    verificcation();
  }, []);

  const handleChangeVariations = (event) => {
    if (!event.target.value) {
      setTagsChanged(``);
    }
    const value = event.target.value;
    getVariationTags(variationTitle, value);
    setTagsChanged([...value]);
  };
  const verificcation = () => {
    for (let i = 0; i < product.productVariations.length; i++) {
      const element = product.productVariations[i];
      if (element.title === variationTitle) {
        const value = [];
        element.variations.map((tag) => {
          value.push(tag.name);
        });
        getVariationTags(variationTitle, value);
        setTagsChanged([...value]);
      }
    }
  };

  return (
    <>
      <FormControl className=" mb-4">
        <InputLabel id="label-input-variation" style={{ paddingTop: "5px" }} className="">{`Variação - ${
          variationTitle || " "
        } `}</InputLabel>
        <Select
          MenuProps={{
            variant: "menu",
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left",
            },
            transformOrigin: {
              vertical: "top",
              horizontal: "left",
            },
            getContentAnchorEl: null,
            classes: { list: classes.menuList },
          }}
          labelId="label-input-variation"
          multiple
          MenuListProps={{}}
          menuList
          value={tagsChanged}
          onChange={(event) => handleChangeVariations(event)}
          input={
            <OutlinedInput
              value={tagsChanged}
              label="label"
              className="fz-16 text-cl-dark-jungle-green ff-univanova p-1"
            />
          }
          renderValue={(selected) => (
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
              {selected.map((value, index) => (
                <Chip key={value + index} label={value} />
              ))}
            </Box>
          )}
        >
          {variationTags.map((name) => (
            <MenuItem className="variations-menu" key={name.name} value={name.name}>
              <Checkbox checked={tagsChanged.indexOf(name.name) > -1} />
              <ListItemText primary={name.name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
};

export default VariationInput;
